module.exports = __webpack_public_path__ + "static/media/documentsIcon.4df8cbf9.svg";